const zeroFill = (value: number) => {
  const stringValue = String(value);
  return stringValue.padStart(2, "0");
};

const HOURS_IN_DAY = 24;
const MS_IN_SECOND = 1000;
const MS_IN_MIN = MS_IN_SECOND * 60;
const MS_IN_HOUR = MS_IN_MIN * 60;
const MS_IN_DAY = MS_IN_HOUR * HOURS_IN_DAY;

export const getTimeDifference = ({ finishDate }: { finishDate: Date }) => {
  const nowDate = new Date();
  const dateDifferenceInMs = finishDate.getTime() - nowDate.getTime();

  const days = Math.floor(dateDifferenceInMs / MS_IN_DAY);
  const hours = Math.floor((dateDifferenceInMs % MS_IN_DAY) / MS_IN_HOUR);
  const minutes = Math.floor((dateDifferenceInMs % MS_IN_HOUR) / MS_IN_MIN);
  const seconds = Math.floor((dateDifferenceInMs % MS_IN_MIN) / MS_IN_SECOND);

  return {
    days: days,
    hours: zeroFill(hours),
    minutes: zeroFill(minutes),
    seconds: zeroFill(seconds),
  };
};
